import React from 'react'
import divider from '../assets/divider.svg'

const Divider = props => (
  <div className="oh">
    <div className="cont divider">
      <img src={divider} alt="divider symbol" />
    </div>
  </div>
)

export default Divider



// WEBPACK FOOTER //
// ./src/components/divider.js